import axios from './axios'
import qs from 'qs'

function query(params) {
    return {
        params: params,
        paramsSerializer: value => qs.stringify(value, {encode: false})
    };
}

function service(endpoint) {

    function fetchAssignments(params) {
        return axios.get(`${endpoint}/doctor-patient-assignments`, query(params)).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchAuditEvents(params) {
        return axios.get(`${endpoint}/audit-events`, query(params)).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchTemplates(params) {
        return axios.get(`${endpoint}/therapy-templates`, query(params)).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchTemplate(id) {
        return axios.get(`${endpoint}/therapy-templates/${id}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchAssignments,
        fetchAuditEvents,
        fetchTemplates,
        fetchTemplate
    }
}

export default service
